<style scoped>
.Animation {
  opacity: 0;
  transform: rotate(-3deg) translate(0px, -50px);
  transition: transform 1000ms, opacity 1000ms;
}

.Animation-isVisible {
  opacity: 1;
  transform: rotate(0deg) translate(0px, 0px);
}
</style>

<template>
  <div class="Animation" :class="class_root" v-observe-visibility="(a) => isVisible(a)">
    <slot></slot>
  </div>
</template>

<script>

import {ListenerRegister} from "../../../../../.bbx/modules/listener~master/core/delta/ListenerRegister";
import {EVENT} from "../../constant/EVENT";
import {eventService} from "../../service/eventService";

export default {
  props: {
    delay: {
      type: Number,
      default: () => 0
    }
  },
  data() {
    return {
      state: {
        isVisible: false,
        animated: true
      },
      events: []
    }
  },
  computed: {
    class_root() {
      const classes = []
      if (this.state.isVisible && this.state.animated) classes.push(`Animation-isVisible`)
      return classes
    }
  },
  beforeMount() {
    this.events.push(new ListenerRegister({
      name: EVENT.START_ANIMATION,
      callback: () => {
        this.state.animated = true
      }
    }))

    // -----

    for (const event of this.events) {
      eventService.register(event)
    }
  },
  beforeDestroy() {
    for (const event of this.events) {
      eventService.unregister(event)
    }
  },
  methods: {
    isVisible(isVisible) {
      setTimeout(() => this.state.isVisible = isVisible, isVisible ? this.delay : 0)
    }
  }
}
</script>